import StepId from "@/model/progress/StepId";

const providerKey = "hfd_standard*"

export default {
    providerKey,

    routes: [
        {
            name: "hfdPaymentPlanReview",
            path: `/providers/${providerKey}/paymentPlanReview`,
            meta: { step: StepId.PAYMENT_OPTIONS },
            props: route => ({ mpf: route.query.mpf }),
            component: () => {
                return import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdPaymentPlanReviewView.vue")
            },
        },
        {
            name: "hfdMPFPaymentPlanReview",
            path: `/providers/${providerKey}/mpfPaymentPlanReview`,
            meta: { step: StepId.PAYMENT_OPTIONS },
            component: () => {
                return import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdMPFPaymentPlanReviewView.vue")
            },
        },
        {
            name: "hfdAdditionalContactInformation",
            path: `/providers/${providerKey}/additionalContactInformation`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () =>
                import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdAdditionalContactInformationView"),
        },
        {
            name: "hfdMPFAdditionalContactInformation",
            path: `/providers/${providerKey}/mpfAdditionalInformation`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () =>
                import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdMPFAdditionalInformationView.vue"),
        },
        {
            name: "hfdDownpayment",
            path: `/providers/${providerKey}/downpayment`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () =>
                import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdDownpaymentCollectionFormView"),
        },
        {
            name: "hfdLoanPayment",
            path: `/providers/${providerKey}/loanPayment`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () =>
                import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdLoanpaymentCollectionFormView"),
        },
        {
            path: `/providers/${providerKey}/terms`,
            name: "hfdTerms",
            extends: "terms",
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdTermsView"),
        },
        {
            name: "acceptOfferError",
            path: `/providers/${providerKey}/acceptOfferError`,
            component: () => import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdTermsView"),
        },

        {
            name: "hfdPauseView",
            path: `/providers/${providerKey}/pause`,
            meta: { step: StepId.COMPLETE },
            component: () => import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdPauseView.vue"),
        },
    ],
}
